const CARGO_FORM = {
  Cargo: '',
  Quantity: '',
  Freight: '',
  Income: '',
  LoadPort: {
    portId: '',
    fullName: '',
    longitude: '',
    latitude: ''
  },
  DischargePort: {
    portId: '',
    fullName: '',
    longitude: '',
    latitude: ''
  },
  AddCommRate: '',
  AddComm: '',
  BrokerageRate: '',
  Brokerage: '',
  FrtTaxRate: '',
  FrtTax: ''
}

const PORT_ROTATION = {
  portSeqInCargos: -1,
  portSeq: -1,
  taskType: '',
  taskTypeName: '',
  port: {
    portId: '',
    fullName: '',
    longitude: '',
    latitude: ''
  },
  distance: '',
  ecaDistance: '',
  speed: '',
  seaDays: '',
  ecaSeaDays: '',
  idleDays: '',
  workDays: '',
  portCharge: '',
  arrived: '',
  departed: '',
  arrivedDate: '',
  arrivedTime: '',
  departedDate: '',
  departedTime: '',
  inEca: ''
}

const FUEL_FORM = {
  ShipID: '',
  ShipName: '',
  SpeedType: '1', //  1-全速 2-经济
  SpeedBallast: 12,
  SpeedLaden: 12,

  DOBallast: '',
  DOPortIdle: '',
  DOPortWork: '',
  DOSea: '',

  FOBallast: '',
  FOLaden: '',
  FOPortIdle: '',
  FOPortWork: ''
}

export default {
  CARGO_FORM,
  PORT_ROTATION,
  FUEL_FORM
}
